import { render, staticRenderFns } from "./FeaturesBlock.vue?vue&type=template&id=de078c12&scoped=true&"
import script from "./FeaturesBlock.vue?vue&type=script&lang=js&"
export * from "./FeaturesBlock.vue?vue&type=script&lang=js&"
import style0 from "./FeaturesBlock.vue?vue&type=style&index=0&id=de078c12&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de078c12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de078c12')) {
      api.createRecord('de078c12', component.options)
    } else {
      api.reload('de078c12', component.options)
    }
    module.hot.accept("./FeaturesBlock.vue?vue&type=template&id=de078c12&scoped=true&", function () {
      api.rerender('de078c12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/blocks/FeaturesBlock.vue"
export default component.exports